import { ActionIcon, Box, Menu } from '@mantine/core';
import {
  IconArchive,
  IconArchiveOff,
  IconDotsVertical,
  IconEye,
  IconTrash,
} from '@tabler/icons-react';
import { CompanyAppendix } from '../../types';

interface AppendixRowActionsProps {
  appendix: CompanyAppendix;
  onView: (appendix: CompanyAppendix) => void;
  onArchive: (appendix: CompanyAppendix) => void;
  onUnarchive: (appendix: CompanyAppendix) => void;
  onDelete: (appendix: CompanyAppendix) => void;
  isUpdating: boolean;
}

export default function AppendixRowActions({
  appendix,
  onView,
  onArchive,
  onUnarchive,
  onDelete,
  isUpdating,
}: AppendixRowActionsProps) {
  return (
    <Box ta="right">
      <Menu position="bottom-end" withinPortal>
        <Menu.Target>
          <ActionIcon variant="subtle" color="gray">
            <IconDotsVertical size={16} />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item leftSection={<IconEye size={14} />} onClick={() => onView(appendix)}>
            View
          </Menu.Item>
          <Menu.Divider />
          {appendix.isArchived ? (
            <>
              <Menu.Item
                leftSection={<IconArchiveOff size={14} />}
                onClick={() => onUnarchive(appendix)}
                disabled={isUpdating}
              >
                Unarchive
              </Menu.Item>
              <Menu.Item
                leftSection={<IconTrash size={14} />}
                color="red"
                onClick={() => onDelete(appendix)}
              >
                Delete
              </Menu.Item>
            </>
          ) : (
            <Menu.Item leftSection={<IconArchive size={14} />} onClick={() => onArchive(appendix)}>
              Archive
            </Menu.Item>
          )}
        </Menu.Dropdown>
      </Menu>
    </Box>
  );
}
